"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get = _interopRequireDefault(require("lodash/get"));
var _staticContentPropCheck = _interopRequireDefault(require("../../utils/content/staticContentPropCheck"));
var _selectModule = _interopRequireDefault(require("./select.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Select = /*#__PURE__*/function (_PureComponent) {
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _callSuper(this, Select, [props]);
    _defineProperty(_this, "onChange", function (evt) {
      var onChange = _this.props.onChange;
      var value = evt.target.value;
      _this.setState({
        value: value
      });
      onChange(evt);
    });
    _defineProperty(_this, "onFocus", function (evt) {
      var onFocus = _this.props.onFocus;
      var value = evt.target.value;
      _this.setState({
        value: value
      });
      onFocus(evt);
    });
    _defineProperty(_this, "onBlur", function (evt) {
      var onBlur = _this.props.onBlur;
      var value = evt.target.value;
      _this.setState({
        value: value
      });
      onBlur(evt);
    });
    _this.state = {
      value: _this.props.value || (0, _get["default"])(_this.props, 'options[0].value')
    };
    return _this;
  }

  /* https://gitlab.com/JohnLewisPartnership/jl-ui/jl-ui-kit/-/issues/237 */
  _inherits(Select, _PureComponent);
  return _createClass(Select, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        className = _this$props.className,
        options = _this$props.options,
        optgroup = _this$props.optgroup,
        name = _this$props.name,
        disabled = _this$props.disabled,
        autoFocus = _this$props.autoFocus,
        required = _this$props.required,
        dataTest = _this$props['data-test'],
        ariaInvalid = _this$props.ariaInvalid,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        ariaLabel = _this$props.ariaLabel;
      var noOptions = !options || options.length === 0;
      var noOptGroup = !optgroup || optgroup.length === 0;
      if (noOptGroup && noOptions) {
        return null;
      }
      var value = this.state.value;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("select", {
        id: id,
        className: (0, _classnames["default"])(_selectModule["default"]['c-select'], className, _selectModule["default"]['joyfully-bold']),
        name: name,
        value: value,
        disabled: disabled,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        required: required,
        "data-test": dataTest,
        "aria-invalid": ariaInvalid,
        "aria-describedby": ariaDescribedBy,
        "aria-label": ariaLabel,
        ref: function ref(el) {
          _this2.select = el;
        },
        children: [options && options.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: option.value,
            disabled: option.disabled,
            hidden: option.hidden,
            children: option.label
          }, option.value);
        }), optgroup && optgroup.map(function (optgroupItem) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("optgroup", {
            label: optgroupItem.label,
            children: optgroupItem.options.map(function (option) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
                value: option.value,
                disabled: option.disabled,
                hidden: option.hidden,
                children: option.label
              }, option.value);
            })
          }, optgroupItem.label);
        })]
      });
    }
  }]);
}(_react.PureComponent);
_defineProperty(Select, "propTypes", {
  /** Unique ID for the select element */
  id: _propTypes["default"].string.isRequired,
  /** Custom class name to be added */
  className: _propTypes["default"].string,
  /** Array of options to be presented */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _staticContentPropCheck["default"],
    disabled: _propTypes["default"].bool,
    hidden: _propTypes["default"].bool
  })).isRequired,
  /** Array of optgroup to be presented */
  optgroup: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _staticContentPropCheck["default"],
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _staticContentPropCheck["default"],
      disabled: _propTypes["default"].bool,
      hidden: _propTypes["default"].bool
    }))
  })),
  /** Optional data-test attribute */
  'data-test': _propTypes["default"].string,
  /** Set the aria-invalid attribute */
  ariaInvalid: _propTypes["default"].string,
  /** Set the aria-label attribute */
  ariaLabel: _propTypes["default"].string,
  /** Set the aria-describedby attribute */
  ariaDescribedBy: _propTypes["default"].string,
  /** Name of the select element */
  name: _propTypes["default"].string.isRequired,
  /** Default value to use if none is selected - this is non-standard to HTML */
  value: _propTypes["default"].string,
  /** Disable the select element */
  disabled: _propTypes["default"].bool,
  /** Function to be called when a change event is fired by the select */
  onChange: _propTypes["default"].func,
  /** Function to be called when the select accepts focus */
  onFocus: _propTypes["default"].func,
  /** Function to be called when the select loses focus */
  onBlur: _propTypes["default"].func,
  /** Focus on this input when the page loads */
  autoFocus: _propTypes["default"].bool,
  /** Mark the select element as a required field */
  required: _propTypes["default"].bool
});
_defineProperty(Select, "defaultProps", {
  className: undefined,
  disabled: false,
  'data-test': undefined,
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  ariaLabel: undefined,
  optgroup: undefined,
  //
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  //
  autoFocus: false,
  required: undefined,
  value: ''
});
var _default = exports["default"] = Select;